var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sports_item_detail sports_register_detail"},[_c('Form',{attrs:{"list":_vm.itemDetail.registerform,"team":_vm.teamform,"buttonColor":_vm.buttonColor,"statement":_vm.itemDetail.statement},on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }